import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.componentSets;

export default class ComponentSets extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      name: this.string(''),
      object_type: this.string('PROCESS'),
      content: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/sets/?:query',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/sets/',
          method: 'post',
        },
      },
    },
  };
}
